import IRailFreightDetails, { ILeg } from "../types/IRailFreightDetails";

const getSafe = (
  obj: Record<string, any> | null,
  path: string | string[],
  defaultValue: any = null,
): any => {
  if (!obj) return defaultValue;
  const keys = Array.isArray(path) ? path : path.split(".");

  const finalValue = keys.reduce((currentObject, key) => {
    if (
      currentObject &&
      typeof currentObject === "object" &&
      key in currentObject
    ) {
      return currentObject[key];
    }
    return undefined;
  }, obj);

  return finalValue ?? defaultValue;
};

// TODO: deprecated
export default function convertRailFreightDetailData(oldRecord: any) {
  const legs = getSafe(oldRecord, "railFreight.legs", []);
  const newRecord: IRailFreightDetails = {
    destination: {
      name: getSafe(oldRecord, "destination.name"),
      station: getSafe(oldRecord, "destination.station"),
      servingCarrier: "",
      address: getSafe(oldRecord, "destination.address"),
    },
    origin: {
      name: getSafe(oldRecord, "origin.name"),
      station: getSafe(oldRecord, "origin.station"),
      servingCarrier: getSafe(oldRecord, "railFreight.legs.0.originCarrier"),
      railroadDoc: getSafe(oldRecord, "railFreight.legs.0.document"),
      baseRate: getSafe(oldRecord, "railFreight.legs.0.rate"),
      fuel: getSafe(oldRecord, "railFreight.legs.0.fsc"),
      miles: getSafe(oldRecord, "railFreight.legs.0.miles"),
      carrier: getSafe(oldRecord, "railFreight.legs.0.carrier"),
      city: getSafe(oldRecord, "origin.city"),
    },
    interchangeLocations: [] as ILeg[],
    route: getSafe(oldRecord, "railFreight.route"),
    carOwner: getSafe(oldRecord, "legs.0.carOwner"),
    minCars: getSafe(oldRecord, "legs.0.minCars"),
    rule11: legs.length !== 1,
    expirationDate: getSafe(oldRecord, "legs.0.exp"),
    sourceSystem: getSafe(oldRecord, "validation.sourceSystem"),
    rate: getSafe(oldRecord, "validation.rate"),
    header: getSafe(oldRecord, "validation.header"),
    notes: getSafe(oldRecord, "validation.notes"),
    isValid: getSafe(oldRecord, "validation.isValid"),
    totalFreight: getSafe(oldRecord, "freight", 0),
  };

  const interchanges =
    getSafe(oldRecord, "railFreight.interchanges", null) ?? [];
  if (interchanges.length === 0) {
    newRecord.route = getSafe(oldRecord, "railFreight.route");

    newRecord.destination.servingCarrier = getSafe(
      oldRecord,
      "railFreight.legs.0.destinationCarrier",
    );
  } else {
    // Original logic: interchanges array is NOT empty
    newRecord.interchangeLocations = interchanges.map(
      (interchangeName: string, index: number) => {
        // For interchangeLocations[i], data comes from freight.legs[i+1]
        const legIndexForInterchange = index + 1;
        return {
          name: interchangeName,
          railroadDoc: getSafe(
            oldRecord,
            `railFreight.legs.${legIndexForInterchange}.document`,
          ),
          baseRate: getSafe(
            oldRecord,
            `railFreight.legs.${legIndexForInterchange}.rate`,
          ),
          fuel: getSafe(
            oldRecord,
            `railFreight.legs.${legIndexForInterchange}.fsc`,
          ),
          carrier: getSafe(
            oldRecord,
            `railFreight.legs.${legIndexForInterchange}.carrier`,
          ),
          miles: getSafe(
            oldRecord,
            `railFreight.legs.${legIndexForInterchange}.miles`,
          ),
        };
      },
    );
    newRecord.destination.servingCarrier = getSafe(
      oldRecord,
      `railFreight.legs.${interchanges.length}.destinationCarrier`,
    );
  }

  return newRecord;
}
